/**
 * Run any provided method in a try/catch block with a fallback value
 *
 * Used for any compute during rendering to avoid killing the entire pipeline
 * if a single element fails to compute its internal properties.
 */
export function safeCompute<T, Fallback = T>({
  method,
  fallback,
  logger,
}: {
  method: () => T
  fallback: Fallback
  logger?: (error: Error) => void
}): T | Fallback {
  try {
    return method()
  } catch (error) {
    if (logger) logger(error as Error)

    return fallback
  }
}
